// Gemeinsame Zuordnung zwischen den internen Keys des Re-Akzept-Status und
// den vom Legal-Fragment-Endpunkt akzeptierten Dokument-Slugs.
export const LEGAL_SLUG_BY_DOCUMENT_KEY = {
  terms: 'agb',
  privacy: 'datenschutz',
  use_terms: 'nutzungsbedingungen',
} as const;

export type LegalDocumentKey = keyof typeof LEGAL_SLUG_BY_DOCUMENT_KEY;
export type LegalSlug = (typeof LEGAL_SLUG_BY_DOCUMENT_KEY)[LegalDocumentKey];
export type LegalServerSlug = LegalSlug | 'impressum';
